/** Origine d'une sortie de production (issue #3620) — miroir de OrigineSortiePourProductionEnum côté back. */
export enum OrigineSortiePourProductionEnum {
  PRESTATION = 'PRESTATION',
  PRODUIT_COMPLEMENTAIRE = 'PRODUIT_COMPLEMENTAIRE',
  PRESTATION_AND_PRODUIT_COMPLEMENTAIRE = 'PRESTATION_AND_PRODUIT_COMPLEMENTAIRE'
}

export const ORIGINE_SORTIE_POUR_PRODUCTION_LABELS: Record<OrigineSortiePourProductionEnum, string> = {
  [OrigineSortiePourProductionEnum.PRESTATION]:                           'Prestation',
  [OrigineSortiePourProductionEnum.PRODUIT_COMPLEMENTAIRE]:                'Produit complémentaire',
  [OrigineSortiePourProductionEnum.PRESTATION_AND_PRODUIT_COMPLEMENTAIRE]: 'Prestation + produit complémentaire',
};
